import config from 'config'

const {
  constants: {
    API: { PRICING_UPDATE_URL },
  },
} = config

export const CASHBUYERS_SEARCH_START = 'CASHBUYERS_SEARCH_START'
export const CASHBUYERS_SEARCH_SUCCESS = 'CASHBUYERS_SEARCH_SUCCESS'
export const CASHBUYERS_SEARCH_ERROR = 'CASHBUYERS_SEARCH_ERROR'
export const CASHBUYERS_SELECT_INVESTOR = 'CASHBUYERS_SELECT_INVESTOR'
export const CASHBUYERS_SET_SORT = 'CASHBUYERS_SET_SORT'
export const CASHBUYERS_SET_RADIUS = 'CASHBUYERS_SET_RADIUS'
export const CASHBUYERS_SET_SUBJECT = 'CASHBUYERS_SET_SUBJECT'
export const CASHBUYERS_SET_TAKE = 'CASHBUYERS_SET_TAKE'
export const CASHBUYERS_SET_CLASSIFICATION = 'CASHBUYERS_SET_CLASSIFICATION'
export const CASHBUYERS_SET_PROPERTY_TYPES = 'CASHBUYERS_SET_PROPERTY_TYPES'
export const CASHBUYERS_TOGGLE_INVESTOR_CHECKED = 'CASHBUYERS_TOGGLE_INVESTOR_CHECKED'
export const CASHBUYERS_CLEAR_CHECKED_INVESTORS = 'CASHBUYERS_CLEAR_CHECKED_INVESTORS'
export const CASHBUYERS_CLEAR = 'CASHBUYERS_CLEAR'

export const setSubjectProperty = (property) => ({
  type: CASHBUYERS_SET_SUBJECT,
  payload: property,
})

export const setRadius = (radius) => ({
  type: CASHBUYERS_SET_RADIUS,
  payload: radius,
})

export const setTake = (take) => ({
  type: CASHBUYERS_SET_TAKE,
  payload: take,
})

export const selectInvestor = (investorId) => ({
  type: CASHBUYERS_SELECT_INVESTOR,
  payload: investorId,
})

export const setSortBy = (sortBy) => ({
  type: CASHBUYERS_SET_SORT,
  payload: sortBy,
})

export const setClassifications = (classifications) => ({
  type: CASHBUYERS_SET_CLASSIFICATION,
  payload: classifications,
})

export const setPropertyTypes = (types) => ({
  type: CASHBUYERS_SET_PROPERTY_TYPES,
  payload: types,
})

export const toggleInvestorChecked = (investorId) => ({
  type: CASHBUYERS_TOGGLE_INVESTOR_CHECKED,
  payload: investorId,
})

export const clearCheckedInvestors = () => ({
  type: CASHBUYERS_CLEAR_CHECKED_INVESTORS,
})

export const clearCashBuyers = () => ({
  type: CASHBUYERS_CLEAR,
})

/**
 * Build the BatchData investor/buybox request from a parsed address and options.
 */
const buildSearchRequest = (address, radius, take, classifications, propertyTypes) => {
  // Parse "123 Main St, City, ST 12345" into components
  const parts = (address || '').split(',').map((s) => s.trim())
  const street = parts[0] || ''
  const city = parts[1] || ''
  let state = ''
  let zip = ''
  if (parts.length >= 3) {
    const stateZip = parts[parts.length - 1]
    const match = stateZip.match(/^(.+?)\s+(\d{5}(-\d{4})?)$/)
    if (match) {
      state = match[1]
      zip = match[2]
    } else {
      state = stateZip
    }
  }

  const investor = {
    acquisitions: {
      totalAcquisitionCountLast36Months: { min: 1 },
    },
    currentHoldings: {
      totalPropertyCount: { min: 1 },
    },
  }

  if (classifications && classifications.length > 0 && classifications.length < 11) {
    if (classifications.length === 1) {
      investor.classification = { equals: classifications[0] }
    } else {
      investor.classification = { inList: classifications }
    }
  }

  const searchCriteria = {
    compAddress: { street, city, state, zip },
    investor,
  }

  if (propertyTypes && propertyTypes.length > 0) {
    if (propertyTypes.length === 1) {
      searchCriteria.general = { propertyTypeCategory: { equals: propertyTypes[0] } }
    } else {
      searchCriteria.general = { propertyTypeCategory: { inList: propertyTypes } }
    }
  }

  return {
    searchCriteria,
    options: {
      useDistance: true,
      distanceMiles: radius,
      useBedrooms: false,
      useBathrooms: false,
      useArea: false,
      useYearBuilt: false,
      useLotSize: false,
      useStories: false,
      take: take,
      skip: 0,
      showMeta: true,
    },
  }
}

export const searchCashBuyers = (address, radius, take, classifications, propertyTypes) => async (dispatch) => {
  dispatch({ type: CASHBUYERS_SEARCH_START })

  try {
    const body = buildSearchRequest(address, radius, take, classifications, propertyTypes)

    const resp = await fetch(`${PRICING_UPDATE_URL}/ps/integrations/cashbuyers/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': window.appAuthToken,
      },
      body: JSON.stringify(body),
    })

    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}))
      throw new Error(err.error?.message || err.message || `API error ${resp.status}`)
    }

    const data = await resp.json()
    const result = data.result || data
    dispatch({
      type: CASHBUYERS_SEARCH_SUCCESS,
      payload: {
        investors: result.investors || [],
        properties: result.properties || [],
        meta: result.meta || {},
        subjectCoords: result.subjectProperty || null,
      },
    })
  } catch (err) {
    dispatch({
      type: CASHBUYERS_SEARCH_ERROR,
      payload: err.message,
    })
  }
}
